import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
      {
        path: '',
        redirect: '/competition-user'
      },
      {
        path: 'competition-user',
        name: 'competition-user',
        component: () => import('../views/cityRepresentative/user.vue')
      },
      {
        path: 'permission-role',
        name: 'permission-role',
        component: () => import('../views/permission/role.vue')
      },
      {
        path: 'permission',
        name: 'permission',
        component: () => import('../views/permission/permission.vue')
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('../views/permission/menu.vue')
      },
      {
        path: 'regionManagement',
        name: 'regionManagement',
        component: () => import('../views/organizingCommittee/regionManagement.vue')
      },
      {
        path: 'competition',
        name: 'competition',
        component: () => import('../views/organizingCommittee/competition.vue')
      },
      {
        path: 'addPlayer',
        name: 'addPlayer',
        component: () => import('../views/cityRepresentative/addPlayer.vue')
      },
      {
        path: 'schedule',
        name: 'schedule',
        component: () => import('../views/schedule/schedule.vue'),
        meta: { matchType: 1, stageName: '初赛', pageTitle: '设置初赛赛程表' }
      },
      {
        path: 'provincial-schedule',
        name: 'provincial-schedule',
        component: () => import('../views/schedule/schedule.vue'),
        meta: { matchType: 2, stageName: '省决赛', pageTitle: '设置省决赛赛程表' }
      },
      {
        path: 'final-schedule',
        name: 'final-schedule',
        component: () => import('../views/schedule/schedule.vue'),
        meta: { matchType: 3, stageName: '总决赛', pageTitle: '全国总决赛赛程安排', adminOnly: true }
      },
      {
        path: 'final-user-audit',
        name: 'final-user-audit',
        component: () => import('../views/organizingCommittee/finalUserAudit.vue'),
        meta: { adminOnly: true }
      },
      {
        path: 'schedule-setup/:id',
        name: 'schedule-setup',
        component: () => import('../views/schedule/scheduleSetup.vue')
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to) => {
  if (!to.matched.some(record => record.meta.adminOnly)) return true

  let userInfo = {}
  try {
    userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  } catch (_) {}

  return Number(userInfo.is_admin) === 1 ? true : { path: '/' }
})

export default router
  
